<div #map class="map-container"></div>

<!-- Top Left Controls -->
<div #topLeftControlsWrapper
  class="top-left-controls-wrapper"
  [ngClass]="{ 'hidden': !mapControlsReady }"
>
  <div #searchControlBtnWrapper *ngIf="mapTilesLoaded">
    <app-search-field
      #searchControl
      [map]="gmap"
      [enableAddressSearch]="true"
      [enableWhat3WordSearch]="true"
      [enableZonesAreasSearch]="true"
      [enableVenueMapsSearch]="true"
      [zones]="zones"
      [areas]="areas"
      [venueMaps]="venueMaps"
      (searchTypeChanged)="onSearchTypeChanged($event)"
      (searchStateChanged)="onSearchStateChanged($event)"
      (autocompleteResult)="onAutocompleteResult($event)"
      (what3WordsResult)="onWhat3WordsResult($event)"
      (venueMapSelected)="onVenueMapSelected($event)"
      (venueMapSelectionCleared)="onVenueMapSelectionCleared()"
    >
    </app-search-field>
  </div>
  <div #myLocationControlBtnWrapper *ngIf="mapTilesLoaded">
    <app-my-location-button (locationAvailableEvent)="onMyLocationAvailable($event)"></app-my-location-button>
  </div>
</div>

<!-- Top Center Controls -->
<div class="top-center-controls-wrapper" #topCenterControlWrapper >
  <app-drawing-controls *ngIf="!newDrawingZonePolygon && drawablesLoaded"
    (drawingStateChanged)="onDrawingStateChanged($event)">
  </app-drawing-controls>
  <app-cancel-drawing-polygon-button *ngIf="newDrawingZonePolygon && drawablesLoaded"
    (clickedEvent)="onCancelDrawingPolygonClicked()"
  >
  </app-cancel-drawing-polygon-button>
</div>

<!-- Top Right Controls -->
<div #topRightControlsWrapper
  [ngClass]="{ 'top-right-controls-wrapper': !isMobile, 'hidden': !mapControlsReady }"
>
  <app-zone-area-toggle-button *ngIf="drawablesLoaded"
    [map]="gmap"
    [zonesPolygon]="zonesPolygon"
    [areasPolygon]="areasPolygon"
  ></app-zone-area-toggle-button>

  <app-venue-maps-toggle-button *ngIf="venueMapsEnabled && drawablesLoaded"
    [map]="gmap"
    [venueMaps]="venueMaps"
    [groundOverlays]="groundOverlays"
    [tileOverlays]="tileOverlays"
  ></app-venue-maps-toggle-button>
</div>

<!-- Bottom Center Controls -->
<div #bottomCenterControlsWrapper class="bottom-center-controls-wrapper">
  <app-map-views-group-button #mapTypesGroupButton *ngIf="mapTilesLoaded"
    [map]="gmap"
    [drawAsMapOverlay]="true">
  </app-map-views-group-button>
</div>
